import { MutableRefObject, useEffect, useRef } from "react";

import useOrderData from "../../context/useOrderData";

const SCROLL_OFFSET = -100;

const useScrollToRecipient = (): MutableRefObject<HTMLDivElement | null> => {
  const ref = useRef<HTMLDivElement>(null);

  const {
    staticData: { isScrollToReceiverInfo },
  } = useOrderData();

  useEffect(() => {
    if (isScrollToReceiverInfo && ref.current) {
      const y = ref.current.getBoundingClientRect().top + window.pageYOffset + SCROLL_OFFSET;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, [isScrollToReceiverInfo]);

  return ref;
};
export default useScrollToRecipient;
